export const enum API {
  JUDGE_TERMINAL = "/judge-terminal/api/v1",
  PUBLIC = "/api/public",
}
